import { faGithub } from '@fortawesome/free-brands-svg-icons';
import {
	faEnvelope,
	faFile,
	faGear,
	faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Navbar({ onTabChange, activeTab }) {
	const handleClick = (tabIndex) => {
		onTabChange(tabIndex);
	};

	return (
		<nav className="navbar">
			<div className="top-icon">
				<FontAwesomeIcon
					icon={faFile}
					size="2x"
					className={`iconHover ${activeTab === 0 ? 'selected' : ''}`}
					onClick={() => handleClick(0)}
				/>

				<FontAwesomeIcon
					icon={faInfoCircle}
					size="2x"
					className={`iconHover ${activeTab === 1 ? 'selected' : ''}`}
					onClick={() => handleClick(1)}
				/>

				<FontAwesomeIcon
					icon={faEnvelope}
					size="2x"
					className={`iconHover ${activeTab === 2 ? 'selected' : ''}`}
					onClick={() => handleClick(2)}
				/>
			</div>

			<div className="bottom-icon">
				<a
					href="https://github.com/massi-17"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon
						icon={faGithub}
						size="2x"
						className="icon-navbar bottom-icon iconHover"
					/>
				</a>
				<a href="http://" target="_blank" rel="noopener noreferrer">
					<FontAwesomeIcon
						icon={faGear}
						size="2x"
						className="icon-navbar bottom-icon iconHover"
					/>
				</a>
			</div>
		</nav>
	);
}

export default Navbar;
